import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Avatar, Button, Comment, Form, Input } from 'antd';
import PropTypes from 'prop-types';
import { getTranslatedString } from 'helpers/i18n';
import { getInitialsForAvatar } from '@yuhuinc/ui-library';
import { getData } from 'actions/landlordDashboardActions';
const { TextArea } = Input;

const Editor = ({ onSubmit, disabled }) => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    onSubmit(values);
    form.resetFields();
  };

  return (
    <Form onFinish={handleSubmit} form={form} disabled={disabled}>
      <Form.Item name="note" rules={[{ required: true }]}>
        <TextArea style={{ marginBottom: 24 }} />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" loading={disabled} type="primary">
          {getTranslatedString(
            'landlordPortal.applicationManagement.applicationOverview.notes.addNote'
          )}
        </Button>
      </Form.Item>
    </Form>
  );
};

const AddNote = ({ onSubmit, disabled = false, userFirstName, userLastName, getData }) => {
  useEffect(() => {
    // Fetch user's first/last name
    getData();
  }, []);

  return (
    <Comment
      avatar={<Avatar>{getInitialsForAvatar(`${userFirstName} ${userLastName}`)}</Avatar>}
      content={<Editor onSubmit={onSubmit} disabled={disabled} />}
    />
  );
};

AddNote.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const mapStoreToProps = (store) => ({
  userFirstName: store.landlordDashboard.data.user_first_name,
  userLastName: store.landlordDashboard.data.user_last_name,
});

export default connect(mapStoreToProps, { getData })(AddNote);
